import moment from 'moment';
import { LitEntity, SirenActionMixin, html } from '../../utility/lit-entity';

class DeviceEvents extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.start = moment().startOf('day').utc().subtract(3, 'week').format();
    this.end = moment().utc().format();
  }

  static get properties() {
    return {
      start: { type: String, reflect: true },
      end: { type: String, reflect: true },
    };
  }

  render() {
    return html``;
  }

  async updated(changedProperties) {
    if (!this.entity || (!changedProperties.has('start') && !changedProperties.has('end'))) {
      return;
    }

    this._setHrefWithStartEnd();
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this._setHrefWithStartEnd();
  }

  _setHrefWithStartEnd() {
    if (!this.entity) {
      return;
    }

    const action = this.entity.getActionByName('custom-date-range');
    const fields = this.getActionFields(action);
    if (fields.get('startDate') === this.start && fields.get('endDate') === this.end) {
      return;
    }

    if (!this.start && !this.end) {
      return;
    }

    this.start && fields.set('startDate', this.start);
    this.end && fields.set('endDate', this.end);
    this.href = this.parseAction(action, fields).url.href;
  }
}

window.customElements.define('device-events', DeviceEvents);
